import { Injectable } from '@angular/core';
import { UserAuthDto } from '../models/dtos';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CONSTANTS } from '../constants';
import { BaseService } from './base.service';
import { ConfigurationService, HttpService } from '.';

@Injectable()
export class SecurityService extends BaseService {
  private auths: UserAuthDto = null;

  private authsObs: BehaviorSubject<UserAuthDto> = new BehaviorSubject<UserAuthDto>(null);

  constructor(httpService: HttpService,
    configurationService: ConfigurationService) {
        super(httpService, configurationService);
}
  
  getAuths(): Observable<UserAuthDto>{
    let authsObservable = this.httpService.get<any>(this.apiUrl + 'account/auths', null)
            .pipe(
                map(result => {
                    if (result) {
                        this.auths = result;
                        this.authsObs.next(this.auths);
                    }

                    return result;
                }));

        return authsObservable;
  }

  getCachedAuths():Observable<UserAuthDto>{
    return this.auths ? of(this.auths): this.authsObs;
  }

  getLegacyToken(): Observable<boolean> {
    var request = this.httpService.get<string>(this.apiUrl + 'account/legacy-token', null)
    .pipe(
      map(result => {
        if (result) {
          localStorage.setItem(CONSTANTS.cacheKeys.token, result);
          return true;
        } else {
          return false;
        }
      })
    );

    return request;
  }

  reset() {
    this.auths = null;
    this.authsObs = new BehaviorSubject(null);
  }
}